const styles = () => ({
    title: {
        margin: '16px 0 0',
        color: '#747474',
        fontSize: '22px',
        fontWeight: 500,
    },
});

export default styles;
